"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShapeViewModel = exports.valueGetterFunction = void 0;
var text_utils_1 = require("../../../../common/text_utils");
var config_1 = require("../config");
var viewmodel_types_1 = require("../types/viewmodel_types");
var group_by_rollup_1 = require("../utils/group_by_rollup");
var viewmodel_1 = require("./viewmodel");
function rawTextGetter(layers) {
    return function (node) {
        var accessorFn = layers[node[group_by_rollup_1.DEPTH_KEY] - 1].nodeLabel || (function (d) { return d; });
        return "" + accessorFn(node.dataName);
    };
}
function valueGetterFunction(valueGetter) {
    return typeof valueGetter === 'function' ? valueGetter : config_1.VALUE_GETTERS[valueGetter];
}
exports.valueGetterFunction = valueGetterFunction;
function getShapeViewModel(spec, parentDimensions, tree, backgroundStyle, style, panelModel) {
    var textMeasurer = document.createElement('canvas');
    var textMeasurerCtx = textMeasurer.getContext('2d');
    if (!textMeasurerCtx) {
        var width = parentDimensions.width, height = parentDimensions.height;
        return (0, viewmodel_types_1.nullShapeViewModel)(spec.layout, style, { x: width / 2, y: height / 2 });
    }
    var valueGetter = valueGetterFunction(spec.valueGetter);
    return (0, viewmodel_1.shapeViewModel)((0, text_utils_1.measureText)(textMeasurerCtx), spec, style, parentDimensions, rawTextGetter(spec.layers), valueGetter, tree, backgroundStyle, panelModel);
}
exports.getShapeViewModel = getShapeViewModel;
//# sourceMappingURL=scenegraph.js.map